import { Documents } from "@/common/types/documents";

export interface MediationAvailability {
  availability: boolean;
  max_months: number;
}

export interface MediationPaymentProps {
  amount: number;
  mediation_fee: string;
  payment_date: string;
  status: number;
  status_label: string;
}

export interface MediationProps {
  agreement_id: number;
  amount: string;
  documents: Documents;
  id: number;
  payments: MediationPaymentProps[];
  redirect_url?: string;
  status: MediationStatus;
  status_label: string;
}

export enum MediationStatus {
  Signing = 1,
  Pending = 2,
  Active = 3,
}
